import { Order } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import PopupToast from '@components/custom-toast'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { modalConfig } from '../../../utils/modalConfig'
import BorrowHistory from './borrow'
import LendHistory from './lend'
import { HistoryContainer, ToggleButton, ToggleContainer } from './style'

type BookType = 'Borrow' | 'Lend'

const History: React.FC = () => {
  const location = useLocation()
  const { activeTab } = location.state || {}
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>()
  const [modalData, setModalData] = useState<any>({})
  const [active, setActive] = useState<BookType>(activeTab ?? 'Lend')
  const handleToggleType = (type: BookType) => {
    setActive(type)
  }

  const handleClickItem = (item: any, type: 'Lend' | 'Borrow') => {
    if (item?.status !== 'Driver Assigned') {
      return
    }

    const configData = modalConfig(item, type)
    setVisible(configData.visible)
    setModalData(configData)
  }

  const onCancel = () => {
    setVisible(false)
    setModalData({})
  }
  const handleConfirm = async () => {
    if (modalData?.payload) {
      setLoading(true)
      await Order.updateStatus(
        modalData?.type === 'Lend' ? 'lendOrder' : 'borrowOrder',
        modalData?.payload,
        modalData?.item?.id,
      )
        .then(() => {
          setVisible(false)
          setModalData({})
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <>
      <BackNavigation title="History" />
      <HistoryContainer>
        <ToggleContainer>
          <ToggleButton
            active={active === 'Lend'}
            onClick={() => handleToggleType('Lend')}
          >
            Lending Book
          </ToggleButton>
          <ToggleButton
            active={active === 'Borrow'}
            onClick={() => handleToggleType('Borrow')}
          >
            Borrowing Book
          </ToggleButton>
        </ToggleContainer>

        <>
          {active === 'Lend' && (
            <LendHistory active={active} handleClickItem={handleClickItem} />
          )}
          {active === 'Borrow' && (
            <BorrowHistory active={active} handleClickItem={handleClickItem} />
          )}
        </>

        <PopupToast
          loading={loading}
          cancelText="Cancel"
          buttonText="Confirm"
          onClose={onCancel}
          onClick={handleConfirm}
          image="deactivate"
          isOpen={visible}
          content={modalData?.description}
        />
      </HistoryContainer>
    </>
  )
}

export default History
